import { GenericAbortSignal } from "axios";
import { AutoCompleteSuggestions, MprcAutoComplete } from "components/MprcAutoComplete";
import { IAutoCompleteProps } from "components/MprcAutoComplete/AutoComplete";
import { SubordinaterAutoCompleteDataModelDto } from "generated/CoreApi_v1";
import { isCanceledError, useCoreApi } from "providers/CoreApiProvider";

////////////////////////////////////////////////////////////////////////////

interface Props extends Omit<IAutoCompleteProps, 'onGetSuggestions' | 'onChange'> {
    managerId: string;
    directSubordinatesOnly: boolean;
    onChange: (items: SubordinaterAutoCompleteDataModelDto[]) => void;
}

////////////////////////////////////////////////////////////////////////////

/**
 * Auto complete de Subordinados.
 * @param props
 */
export const SubordinatesAutoComplete: React.FC<Props> = ({ managerId, directSubordinatesOnly, onChange, onError, ...props }) => {

    const api = useCoreApi();

    ///
    const getSuggestions = (searchText: string, pageNumber: number, pageSize: number, trySelectedHistory: boolean, signal: GenericAbortSignal | undefined): Promise<AutoCompleteSuggestions<SubordinaterAutoCompleteDataModelDto>> => {
        searchText = searchText.toLowerCase();

        return new Promise<AutoCompleteSuggestions<SubordinaterAutoCompleteDataModelDto>>((resolve) => {
            api.v1.suggestions.subordinates({
                managerId,
                directSubordinatesOnly,
                searchText,
                pageNumber,
                pageSize
            }, { signal })
                .then(result => resolve({
                    items: result.data.items as SubordinaterAutoCompleteDataModelDto[],
                    totalRows: result.data.totalRows
                }))
                .catch(e => {
                    if (!isCanceledError(e)) {
                        resolve({ items: [], totalRows: 0 });
                        if (onError) onError(e);
                    }
                });
        });
    };

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <MprcAutoComplete
            {...props}
            singleSelectMode="text"
            multiSelect={false}
            onError={onError}
            onGetSuggestions={getSuggestions}
            onChange={items => onChange(items as SubordinaterAutoCompleteDataModelDto[])}
        />
    );
};
